import React from 'react'
import cx from 'classnames'
import { FundDistribution } from '../../../../../components'
import { useSelector } from 'react-redux'
import { agencyApiSelectors } from 'modules/api/agency'
import { portfolioApiSelectors } from 'modules/api/portfolio'
import { partyApiSelectors } from 'modules/api/party'

interface InvoiceType {
  name: string | null
  value: string | null
}

interface Beneficiary {
  name?: string
  partyId?: string
  partyTag?: string
  reference?: string
  amount?: number | string
  vat?: boolean
}

interface PaymentAllocationProps {
  errors?: any
  invoiceType?: InvoiceType
  invoiceStatus?: string
  balance?: number
  availableFunds: number | string
  onNewBeneficiaryAdded?: (beneficiary: any) => any
  onNewBeneficiaryAmountChange?: (...args: any[]) => any
  onBeneficiariesOrderChange?: (...args: any[]) => any
  beneficiaries?: Beneficiary[]
  beneficiariesHash?: string | null
  portfolioId?: string
}

const PaymentAllocation = (props: PaymentAllocationProps): React.ReactElement => {
  const {
    errors,
    invoiceType = { name: null, value: null },
    invoiceStatus,
    balance,
    onNewBeneficiaryAdded = (beneficiary: any) => beneficiary,
    onNewBeneficiaryAmountChange,
    onBeneficiariesOrderChange,
    beneficiaries = [],
    beneficiariesHash,
    portfolioId,
  } = props

  const getPrimaryLandlordByPortfolioId = useSelector(portfolioApiSelectors.getPrimaryLandlordByPortfolioId)
  const propertyOwnerId = getPrimaryLandlordByPortfolioId(portfolioId)
  const propertyOwnerName = useSelector((state: any) => partyApiSelectors.getPartyNameById(state)(propertyOwnerId))
  const propertyOwnerBankDetails = useSelector((state: any) =>
    partyApiSelectors.getPartyBankDetails(state)(propertyOwnerId),
  )

  const classes = cx('root', {
    'status-ready': invoiceStatus === 'Ready',
  })

  return (
    <div className={classes}>
      <FundDistribution
        readonly
        errors={errors.beneficiaries}
        invoiceType={invoiceType}
        state={invoiceStatus === 'Short' ? 'warning' : 'default'}
        headerText="Payment Allocation"
        invoiceStatus={invoiceStatus}
        balance={balance}
        onNewBeneficiaryAdded={onNewBeneficiaryAdded}
        onNewBeneficiaryAmountChange={onNewBeneficiaryAmountChange}
        onBeneficiariesOrderChange={onBeneficiariesOrderChange}
        beneficiaries={beneficiaries}
        propertyOwnerName={propertyOwnerName}
        propertyOwnerId={propertyOwnerId}
        propertyOwnerBankDetails={propertyOwnerBankDetails}
        beneficiariesKey={beneficiariesHash}
      />
    </div>
  )
}

export default PaymentAllocation
